import { AdminBreadcrumb, AdminTitle } from "@/shared";
import { AdminLogPath, AdminLogTitle } from "@/entities";
import { AdminLogsList, AdminLogsButtons } from "@/features";

export function AdminLogListPage() {
  return (
    <>
      <div className="d-flex align-items-center">
        <div>
          <AdminBreadcrumb items={AdminLogPath} />
          <AdminTitle title={AdminLogTitle} />
        </div>
        <div className="ms-auto">
          <div className="mb-3px">
            <span className="badge me-1 bg-success">정상</span>
            <span className="badge me-1 bg-danger">에러</span>
          </div>
        </div>
      </div>

      {/* <LogsAlert /> */}
      <AdminLogsButtons />

      <AdminLogsList />
    </>
  );
}
